/* eslint-disable react-hooks/exhaustive-deps */
import notice from 'src/common/components/Notice';
import React, { useState, useEffect } from 'react';
import { defaultSessions } from './utils/list_data';
import BaseModal from 'src/common/components/Modal';
import ConfirmacionModal from './ConfirmacionModal';
import Calendar from 'src/common/components/Calendar';
import { sessionsAPI } from 'src/api/modules/sessions';
import interactionPlugin from '@fullcalendar/interaction';
import { getColorEvent } from 'src/utils/getColorsCalendar';

const CalendarModal = ({ open, setOpen, idSession, onConfirmDate, organoID }) => {
	const [session, setsessions] = useState(defaultSessions);
	const [dateCalendar, setDateCalendar] = useState();
	const [confirmationModal, setConfModal] = useState(false);
	const [selectDate, setSelectDate] = useState();

	useEffect(() => {
		if (organoID !== '' && open) getSessions();
	}, [organoID, dateCalendar]);

	const getSessions = () => {
		setsessions([]);
		sessionsAPI
			.getByDate(organoID, dateCalendar?.startDate, dateCalendar?.endDate)
			.then((response) => {
				if (response.sesiones && response.sesiones.length > 0) {
					let sessions = [];
					response.sesiones.forEach((r) => {
						let date = r.fecha;
						let formattedDate = date.split('-').reverse().join('-');
						let timeFormat = formattedDate + 'T' + r.hora;
						sessions.push({
							id: r.id,
							title: r.nombre_corto,
							start: timeFormat,
							eventColor: getColorEvent(timeFormat),
							borderColor: getColorEvent(timeFormat),
						});
					});
					setsessions([...(sessions || [])]);
				}
			})
			.catch((e) => {
				notice('Ocurrio un error al cargar calendario de sesiones');
			});
	};

	const handleDateClick = (date) => {
		if (idSession == null) {
			setSelectDate(date.dateStr);
			setConfModal(true);
		} else setConfModal(false);
	};

	const getDates = (dates) => {
		let initialDates = {
			startDate: new Date(dates?.startStr).toLocaleDateString(),
			endDate: new Date(dates?.endStr).toLocaleDateString(),
		};
		setDateCalendar(initialDates);
	};
	return (
		<BaseModal
			open={open}
			mainText={
				idSession == null
					? 'Seleccione una fecha para crear una nueva sesión'
					: 'Consulta de sesiónes'
			}
			onClose={() => setOpen(false)}
			onCancel={() => setOpen(false)}
			maxWidth="md"
		>
			<Calendar
				data={session}
				plugins={interactionPlugin}
				datesSet={(info) => getDates(info)}
				dateClick={(date) => handleDateClick(date)}
			/>
			<ConfirmacionModal
				open={confirmationModal}
				setOpen={setConfModal}
				date={selectDate}
				closeAll={setOpen}
				cancel={setSelectDate}
				onConfirmDate={onConfirmDate}
			/>
		</BaseModal>
	);
};

export default CalendarModal;
